import React, { useEffect, useMemo, useRef, useState } from 'react';

// CORE COMPONENTS
import Tooltip from 'core/tools/Tooltip';

const createTaskList = (comments) => {
  return (
    <div>
      <b>Open Tasks ({comments.length})</b>
      <hr></hr>
      <ul className='list-unstyled'>
        { comments?.map((v) =>
          <li className='mb-3' key={v.comment}>
            {v.comment.replace(/\(.*?<a .*?>.*?<\/a>.*?\)/g, '')}
          </li>
        ) }
      </ul>
    </div>
  )
}

// MAIN COMPONENT
const TotalTasksCell = ({
  row: { original },
  value
}) => {
  const cellRef = useRef(null);
  const [tooltipPlacement, setTooltipPlacement] = useState('bottom');

  const tip = useMemo(() => (
    createTaskList(original.aryOpenTaskComment)
  ), [original.aryOpenTaskComment]);

  const updateTooltipPlacement = () => {
    if (cellRef.current) {
      const boundingRect = cellRef.current.getBoundingClientRect();
      setTooltipPlacement(boundingRect.top > window.innerHeight / 2 ? 'top' : 'bottom');
    }
  };

  useEffect(() => {
    updateTooltipPlacement();
    window.addEventListener('scroll', updateTooltipPlacement);

    return () => {
      window.removeEventListener('scroll', updateTooltipPlacement);
    };
  }, []);

  return value > 0
    ? <div ref={cellRef}>
        <Tooltip placement={tooltipPlacement} tip={tip}>
          <a href='/deal-tasks'>{value}</a>
        </Tooltip>
      </div>
    : value;
};

// EXPORT
export default TotalTasksCell;
